import { render, staticRenderFns } from "./verify-phone.vue?vue&type=template&id=04f9c4a6&"
import script from "./verify-phone.vue?vue&type=script&lang=js&"
export * from "./verify-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports